<template>
  <div class="app-content content">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row"></div>
      <div class="content-body">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <a class="brand-logo" href="javascript:void(0);"></a>
            <div class="d-none d-lg-flex col-lg-8 align-items-center">
              <div
                class="
                  w-100
                  d-lg-flex
                  align-items-center
                  justify-content-center
                "
              >
                <img :src="$assets('images/connexion.png')" alt="Login V2" />
              </div>
            </div>
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div
                class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto"
                style="margin-top: -200px"
              >
                <img
                  class="img-fluid ml-2"
                  :src="$assets('images/logo.png')"
                  alt=""
                />
                <!-- <form class="auth-login-form mt-3">
                  <div class="mb-2">
                    <i data-feather="chevron-left"></i
                    ><span style="font-size: 12px; cursor: pointer"
                      ><u @click="back()">Retour</u></span
                    >
                  </div>
                  <h4 class="card-title font-weight-bold mb-1">Connexion</h4>
                  <p>
                    Veuillez entrer votre mot de Passe
                   
                  </p>
                  <div class="form-group">
                    <label class="">Mot de Passe</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text"
                          ><i data-feather="user"></i
                        ></span>
                      </div>
                      <input
                        class="form-control"
                        v-model="form.password"
                        type="password"
                      />
                    </div>
                    <div v-if="errors.password" style="color: red">
                      {{ errors.password[0] }}
                    </div>
                  </div>
                  <button
                    v-if="!loading"
                    @click.prevent="submitPassword()"
                    class="btn btn-primary btn-block"
                  >
                    Connexion
                  </button>
                  <button
                    v-else
                    class="btn btn-primary btn-block"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="ml-25 align-middle">Loading...</span>
                  </button>
                </form> -->
                <form
                  class="auth-login-form mt-3"
                  autocomplete="off"
                >
                  <h4 class="card-title font-weight-bold mb-1">
                    Création de votre mot de passe
                  </h4>
                  <div class="form-group">
                    <label class="form-label">Mot de Passe</label>
                    <input type="password" class="form-control" v-model="form.password" />
                    <div v-if="errors.password" style="color: red">
                      {{ errors.password[0] }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Confirmer Mot de Passe</label>
                    <input type="password" class="form-control" v-model="form.conf_password" />
                    <div v-if="errors.conf_password" style="color: red">
                      {{ errors.conf_password[0] }}
                    </div>
                  </div>
                  <button
                    v-if="!loading"
                    class="btn btn-primary btn-block"
                    @click.prevent="registerPassword()"
                  >
                    Valider
                  </button>
                  <button
                    v-else
                    class="btn btn-primary btn-block"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="ml-25 align-middle">Loading...</span>
                  </button>
                </form>
                <p class="text-center mt-2">
                  <span style="font-size: 12px"
                    >En utilisant cette application, vous acceptez nos
                    <a
                      :href="$assets('terms')"
                      target="_blank"
                      style="color: #002a85"
                      >conditions d'utilisation</a
                    ></span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { api } from "../../../helpers/shared";
export default {
  name: "create-password",
  props: {
    route: {
      type: String,
      default: () => "",
    },
    admin: {
      type: String,
      default: () => "",
    },
  },
  data: () => ({
    form: {
      username: "",
      code: "",
      password:"",
      password_conf:"",
    },
    errors: [],
    loading: false,
  }),
  methods: {
    back() {
      this.$storage.removeItem("key_phone");
      this.$router("login");
    },
    //verify-password
    registerPassword(){
      this.loading = true;
      axios
        .post(api("auth/create-password"), this.form)
        .then((response) => {
          this.loading = false;
          this.errors = [];
          if (response.data.status) {
            this.$storage.setItem(
              "key_phone",
              this.$storage.encryptString(this.form.username)
            );
            this.form.username = "";
            this.$router("verify");
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
          } else {
            this.errors = error.response.data.errors;
          }
        });
    },

  },
  mounted() {
    if (this.$storage.getItem("key_phone")) {
      this.form.username = this.$storage.decryptString(
        this.$storage.getItem("key_phone"),
      );
    } else {
      this.form.username = "";
    }
  },
};
</script>

<style scoped>
</style>
